import classNames from "classnames";
import { Link } from "react-router-dom";

export interface SimpleTableColumn {
  label: React.ReactNode;
  className?: string;
}

interface SimpleTableProps {
  columns: SimpleTableColumn[];
  children: React.ReactNode;
  className?: string;
}

export function SimpleTable({
  columns,
  children,
  className,
}: SimpleTableProps) {
  return (
    <table className={classNames("w-full text-sm", className)}>
      <thead>
        <tr className="border-b text-left text-muted">
          {columns.map((col, i) => (
            <th
              key={i}
              className={classNames("py-2 font-medium", col.className)}
            >
              {col.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  );
}

export function SimpleTableRow({
  children,
  className,
  onClick,
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLTableRowElement>) => void;
}) {
  const interactive = typeof onClick === "function";
  const handleClick = (event: React.MouseEvent<HTMLTableRowElement>) => {
    const target = event.target as HTMLElement;
    if (target.closest("a, button")) return;
    onClick?.(event);
  };
  return (
    <tr
      className={classNames(
        "border-b",
        { "cursor-pointer hover:bg-page transition-colors": interactive },
        className,
      )}
      onClick={interactive ? handleClick : undefined}
    >
      {children}
    </tr>
  );
}

export function SimpleTableCell({
  children,
  className,
  to,
}: {
  children: React.ReactNode;
  className?: string;
  to?: string;
}) {
  return (
    <td className={classNames("py-2", className)}>
      {to ? <Link to={to}>{children}</Link> : children}
    </td>
  );
}
